import { CSSProperties } from 'react';
import type { ThemeColors } from '../../components/uchat/UCIndependentChat/hooks/useTheme';

export interface UChatPageStyles {
  container: CSSProperties;
  mainContainer: CSSProperties;
  contentWrapper: CSSProperties;
  userWelcome: CSSProperties;
  avatar: CSSProperties;
  userInfo: CSSProperties;
  userName: CSSProperties;
  loadingOverlay: CSSProperties;
  chatContainer: CSSProperties;
  chatWrapper: CSSProperties;
  chatHeader: CSSProperties;
  headerContent: CSSProperties;
  categoryInfo: CSSProperties;
  categoryLabel: CSSProperties;
  categoryName: CSSProperties;
  switchButton: CSSProperties;
  categorySelectorContainer: CSSProperties;
  categorySelectorGrid: CSSProperties;
  categoryButton: CSSProperties;
  categoryButtonUnselected: CSSProperties;
}

export const createUChatPageStyles = (screens: any, colors: ThemeColors): UChatPageStyles => {
  // 使用动态视口高度（dvh）来更好地处理移动端浏览器地址栏
  const viewportHeight = screens.xs ? "100dvh" : "100vh";
  
  return {
    container: {
      display: "flex",
      flexDirection: "column",
      margin: 0,
      minHeight: viewportHeight,
      height: viewportHeight,
      background: colors.background,
      transition: "background-color 0.3s ease",
      overflow: "hidden",
      position: "relative",
    },
    mainContainer: {
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      padding: screens.xs ? "8px 12px" : "12px 16px",
      minHeight: viewportHeight,
      height: viewportHeight,
      background: colors.background,
      transition: "background-color 0.3s ease",
      overflow: "hidden",
    },
  contentWrapper: {
    width: "100%",
    maxWidth: screens.xs ? "100%" : "800px",
    background: "transparent", // 使用透明背景，与主背景一致
    padding: screens.xs ? "12px 16px" : "20px 24px",
    // 移除阴影和模糊效果，让它看起来是页面的一部分而不是弹框
    transition: "background-color 0.3s ease",
  },
  userWelcome: {
    textAlign: "center",
    marginBottom: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
  },
  avatar: {
    width: "40px",
    height: "40px",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    fontSize: "18px",
    fontWeight: "bold",
  },
  userInfo: {
    // 空对象，用于扩展
  },
  userName: {
    margin: 0,
    color: colors.evaluationMeta,
    fontWeight: 500,
    fontSize: screens.xs ? "20px" : "24px",
    transition: "color 0.3s ease",
  },
  loadingOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: colors.imageLoadingBg,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
    backdropFilter: "blur(3px)",
    transition: "background-color 0.3s ease",
  },
  chatContainer: {
    flex: 1,
    display: "flex",
    minHeight: screens.xs ? "100dvh" : "calc(100vh - 80px)",
    height: screens.xs ? "100dvh" : "calc(100vh - 80px)",
    width: "100%",
    maxWidth: "1200px",
    margin: "0 auto",
    padding: screens.xs ? "0" : "20px 0",
    overflow: "hidden",
    position: "relative",
  },
  chatWrapper: {
    flex: 1,
    background: colors.messageBg,
    boxShadow: `0 8px 32px ${colors.shadow}`,
    overflow: "hidden", // 保持 hidden，防止内容溢出
    margin: screens.xs ? 0 : "0 20px",
    display: "flex",
    flexDirection: "column",
    transition: "background-color 0.3s ease, box-shadow 0.3s ease",
    height: "100%",
    minHeight: 0, // 重要：允许 flex 子元素缩小
  },
  chatHeader: {
    padding: "12px 20px",
    borderBottom: `1px solid ${colors.border}`,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    background: colors.messageBg,
    transition: "background-color 0.3s ease, border-color 0.3s ease",
  },
  headerContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    textAlign: "center",
    // 不占满整行，避免与左侧返回按钮空间竞争
    width: "auto",
  },
  categoryInfo: {
    // 空对象，用于扩展
  },
  categoryLabel: {
    color: colors.textSecondary,
    fontSize: "14px",
    transition: "color 0.3s ease",
  },
  categoryName: {
    color: colors.evaluationMeta,
    fontWeight: 500,
    marginLeft: "8px",
    transition: "color 0.3s ease",
  },
  switchButton: {
    padding: "4px 8px",
  },
  categorySelectorContainer: {
    margin: "0px 20px 0 20px",
    border: `1px solid ${colors.border}`,
    borderRadius: 10,
    padding: 16,
    background: colors.messageBg,
    transition: "background-color 0.3s ease, border-color 0.3s ease",
  },
  categorySelectorGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: 16,
  },
  categoryButton: {
    height: 30,
    borderRadius: 10,
    fontSize: 10,
    fontWeight: 500,
    border: "none",
  },
  categoryButtonUnselected: {
    background: colors.hoverBg,
    color: colors.text,
    border: "none",
    transition: "background-color 0.3s ease, color 0.3s ease",
  },
  };
};
